/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePractitioner200ResponseData } from './CreatePractitioner200ResponseData';
import {
    CreatePractitioner200ResponseDataFromJSON,
    CreatePractitioner200ResponseDataFromJSONTyped,
    CreatePractitioner200ResponseDataToJSON,
    CreatePractitioner200ResponseDataToJSONTyped,
} from './CreatePractitioner200ResponseData';

/**
 *
 * @export
 * @interface CreatePractitioner200Response
 */
export interface CreatePractitioner200Response {
    /**
     *
     * @type {CreatePractitioner200ResponseData}
     * @memberof CreatePractitioner200Response
     */
    data: CreatePractitioner200ResponseData;
}

/**
 * Check if a given object implements the CreatePractitioner200Response interface.
 */
export function instanceOfCreatePractitioner200Response(value: object): value is CreatePractitioner200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreatePractitioner200ResponseFromJSON(json: any): CreatePractitioner200Response {
    return CreatePractitioner200ResponseFromJSONTyped(json, false);
}

export function CreatePractitioner200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePractitioner200Response {
    if (json == null) {
        return json;
    }
    return {

        'data': CreatePractitioner200ResponseDataFromJSON(json['data']),
    };
}

export function CreatePractitioner200ResponseToJSON(json: any): CreatePractitioner200Response {
    return CreatePractitioner200ResponseToJSONTyped(json, false);
}

export function CreatePractitioner200ResponseToJSONTyped(value?: CreatePractitioner200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'data': CreatePractitioner200ResponseDataToJSON(value['data']),
    };
}
